/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendScenarioItemDto } from '../../models/backend-scenario-item-dto';

export interface ListScenariosProjectsProjectIdScenariosGet$Params {
  project_id: number;
}

export function listScenariosProjectsProjectIdScenariosGet(
  http: HttpClient,
  rootUrl: string,
  params: ListScenariosProjectsProjectIdScenariosGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendScenarioItemDto>>> {
  const rb = new RequestBuilder(rootUrl, listScenariosProjectsProjectIdScenariosGet.PATH, 'get');
  if (params) {
    rb.path('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendScenarioItemDto>>;
    }),
  );
}

listScenariosProjectsProjectIdScenariosGet.PATH = '/projects/{project_id}/scenarios';
